import { HttpContext, HttpContextToken } from '@angular/common/http';

export const SKIP_GLOBAL_ERROR = new HttpContextToken<boolean>(() => false);
export const SKIP_LOADING_SPINNER = new HttpContextToken<boolean>(() => false);

export function withLocalErrorHandling(context: HttpContext = new HttpContext()): HttpContext {
    return context.set(SKIP_GLOBAL_ERROR, true);
}

/**
 * Use this for background/async API calls where loading spinner should not be displayed
 */
export function withBackgroundRequest(context: HttpContext = new HttpContext()): HttpContext {
    return context.set(SKIP_LOADING_SPINNER, true);
}

/**
 * Combines both: skip error handling and skip loading spinner
 */
export function withSilentBackgroundRequest(context: HttpContext = new HttpContext()): HttpContext {
    return context.set(SKIP_GLOBAL_ERROR, true).set(SKIP_LOADING_SPINNER, true);
}
